export default __webpack_public_path__ + "static/media/wics.5ba97a2f.png";